export default __webpack_public_path__ + "static/media/farwestfungi_header.17a268c6.jpg";